export default {
  title: "Configurações",
  description: "Gerencie as configurações da sua organização, usuários e workspaces.",
  tabs: {
    organization: "Organização",
    subscription: "Assinatura",
    models: "Modelos de IA",
    users: "Usuários",
    workspaces: "Workspaces",
    general: "Geral",
    logs: "Logs",
    feedback: "Feedback",
    assistant: "Assistente",
    engine: "Engine",
    queues: "Filas",
    plans: "Planos",
    templates: "Templates",
    dangerZone: "Segurança",
    facets: "Facetas",
    emailService: "Serviço de Email",
    emailTemplates: "Templates de Email",
    emailNotifications: "Notificações de Email"
  },
  v2: {
    groups: {
      organization: "Organização",
      access: "Acesso"
    }
  },
  superAdmin: {
    title: "Super Admin"
  },
  assistant: {
    description: "Gerencie as configurações do Prodgy Assistant"
  },
  queues: {
    description: "Gerencie filas e agendamentos do assistente"
  },
  templates: {
    comingSoon: "Em breve",
    tabs: {
      dashboards: "Dashboards",
      emails: "Emails",
      agents: "Agentes",
      integrations: "Integrações"
    }
  },
  sidebar: {
    email: "Email",
    emailService: "Serviço",
    emailTemplates: "Templates",
    emailNotifications: "Notificações",
    emailSender: "Remetente",
  },
  models: {
    title: "Modelos de IA",
    description: "Configuração de IA padrão da organização.",
    updateSuccess: "Configuração de IA atualizada",
    updateSuccessDescription: "O provedor e o modelo padrão foram salvos com sucesso.",
    updateError: "Erro ao atualizar configuração de IA",
    noDeclaredModels: "Esta integração não declara nenhum modelo para este uso.",
    offCatalog:
      "O modelo gravado não está declarado no cadastro desta integração. Escolha um da lista antes de salvar.",
    searchModels: "Buscar modelos",
    test: {
      running: "Testando os modelos...",
      unreachable: "Não foi possível executar o teste. A configuração foi salva.",
      title: "Teste de conexão",
      conversational: "Modelo conversacional",
      embedding: "Modelo de embedding",
      skipped: "Não informado",
      ok: "Funcionando em {{route}}",
      failed: "Falhou em {{route}}",
      routeFrom: {
        declared: "rota declarada no cadastro",
        default: "rota padrão, o modelo não está declarado no cadastro",
        invalid_declaration: "o cadastro declara um valor inválido em `api`, então foi usada a rota padrão",
      },
      reason: {
        route_rejected: "O provedor recusou este modelo neste endpoint. A rota declarada para ele está errada.",
        invalid_credential: "A credencial da integração foi recusada.",
        model_not_found: "O provedor não encontrou este modelo. Confira o nome do deployment e a versão de API.",
        provider_unavailable: "O provedor não respondeu. Isso não indica erro de cadastro — tente de novo.",
        gateway_rejected: "O gateway recusou esta chamada antes de chegar ao provedor. Repetir devolve o mesmo — o cadastro é que precisa mudar.",
        unexpected: "Falha inesperada ao chamar o provedor.",
      },
      askSuperadmin: "Peça a um superadmin a correção de `metadata.models` no cadastro desta integração.",
      unavailable: {
        no_default_model: "Nenhum modelo padrão selecionado — não há o que testar.",
        integration_not_found: "A integração do modelo padrão não foi encontrada.",
        not_llm: "A integração selecionada não tem um modelo conversacional configurado.",
        creds_failed: "Não foi possível ler a credencial desta integração.",
        gateway_not_configured: "O gateway de LLM não está configurado neste ambiente; o teste não foi executado.",
      },
    },
  },
  organization: {
    title: "Organização",
    description: "Gerencie as configurações da sua organização",
    noProfile: "Informação",
    noProfileDescription: "Seu perfil não está associado a uma organização.",
    loadError: "Erro ao carregar dados da organização:",
    unknownError: "Erro desconhecido",
    name: "Nome",
    namePlaceholder: "Digite o nome da organização",
    nameRequired: "O nome da organização é obrigatório",
    website: "Website",
    websitePlaceholder: "Digite o website da organização",
    websiteInvalid: "Digite uma URL válida (ex.: https://exemplo.com)",
    info: "Informações",
    infoPlaceholder: "Digite informações adicionais sobre a organização",
    defaultModel: "Provedor de IA",
    conversationalProvider: "Provedor de Conversa",
    embeddingProvider: "Provedor de Embedding",
    defaultModelName: "Modelo Conversacional",
    defaultModelNamePlaceholder: "Ex: gpt-4o, claude-sonnet-4-6",
    defaultModelNameHelp: "Usado nas conversas do Playground e dos agentes.",
    defaultEmbeddingModel: "Modelo de Embedding",
    defaultEmbeddingModelPlaceholder: "Ex: text-embedding-ada-002, text-embedding-3-small",
    defaultEmbeddingModelHelp: "Usado pela Base de Conhecimento para embedar documentos e queries de busca.",
    selectModel: "Selecione um provedor",
    noModel: "Nenhum provedor",
    noModelsAvailable: "Nenhum provedor disponível",
    unknownModel: "Modelo desconhecido",
    logo: "Logo",
    logoUpdateSuccess: "Logo atualizado com sucesso",
    logoUpdateSuccessDescription: "O logo da sua organização foi atualizado.",
    logoUpdateError: "Erro ao atualizar logo",
    logoUpdateErrorDescription: "Ocorreu um erro ao atualizar o logo da sua organização.",
    logoUpload: {
      title: "Logo da Organização",
      description: "Arraste e solte uma imagem ou clique para selecionar",
      uploadButton: "Fazer upload",
      removeButton: "Remover",
      uploadError: "Erro ao fazer upload da imagem",
      invalidType: "Tipo de arquivo inválido. Use PNG, JPG ou JPEG",
      invalidSize: "Tamanho máximo permitido: 5MB",
    },
    updateSuccess: "Organização atualizada com sucesso",
    updateSuccessDescription: "As configurações da sua organização foram salvas.",
    updateError: "Erro ao atualizar organização",
    updateErrorDescription: "Ocorreu um erro ao atualizar as configurações da sua organização.",
    saveSuccess: "Organização atualizada com sucesso",
    saveError: "Erro ao salvar organização",
    dangerZone: {
      title: "Zona de Perigo",
      description: "Ações irreversíveis que afetam permanentemente sua organização.",
      deleteTitle: "Excluir Organização",
      deleteDescription: "Uma vez excluída, não há como voltar atrás. Por favor, tenha certeza.",
      deleteButton: "Excluir Organização",
      confirmTitle: "Confirmar Exclusão da Organização",
      confirmDescription: "Esta ação é permanente e não pode ser desfeita. Todos os dados serão perdidos.",
      confirmLabel: "Digite o nome da organização para confirmar",
      confirmHint: "Digite",
      confirmButton: "Excluir Permanentemente",
      deleting: "Excluindo...",
      deletingTitle: "Excluindo Organização",
      deletingDescription: "Excluindo {{name}} e todos os seus dados. Por favor, aguarde...",
      deletingStep: "Processando exclusão",
      deletingMessage: "Removendo todos os dados da organização...",
      deletedMessage: "Organização excluída com sucesso",
      deleteSuccess: "Organização excluída com sucesso",
      deleteError: "Erro ao excluir organização",
      deleteErrorDescription: "Ocorreu um erro ao excluir a organização.",
      deleteErrorInvalid: "Organização inválida",
      deleteErrorNameMismatch: "O nome da organização não corresponde",
      deleteErrorWorkspaces: "Não é possível excluir organização com workspaces",
      deleteErrorWorkspacesDescription: "Remova todos os workspaces antes de excluir a organização."
    }
  },
  users: {
    title: "Gerenciamento de Usuários",
    description: "Gerencie os usuários da sua organização.",
    inviteTitle: "Convidar Usuário",
    inviteDescription: "Convide usuários para acessar os agentes de IA dos seus workspaces.",
    organizationUsersTitle: "Usuários da Organização",
    activeUsersTab: "Usuários Ativos",
    pendingInvitesTitle: "Convites Pendentes",
    pendingInvitesTab: "Convites Pendentes",
    awaitingAccess: "Aguardando acesso",
    inviteCancelSuccess: "Convite cancelado",
    inviteCancelSuccessDescription: "O convite foi cancelado com sucesso.",
    inviteCancelError: "Erro ao cancelar convite",
    inviteCancelErrorDescription: "Ocorreu um erro ao cancelar o convite.",
    noOrganizationUsers: "Nenhum usuário encontrado na organização",
    noInvites: "Nenhum convite pendente",
    fields: {
      name: "Nome",
      email: "Email",
      role: "Função",
      status: "Status",
      workspaces: "Workspaces"
    },
    roles: {
      admin: "Administrador",
      user: "Usuário",
      superadmin: "Super Admin"
    },
    noWorkspaces: "Nenhum workspace vinculado",
    superadminAllWorkspaces: "Super Admins têm acesso a todos os workspaces",
    superadminSectionTitle: "Super Admins",
    otherWorkspaces: "Outros workspaces",
    workspacesList: "Lista de workspaces",
    noName: "Sem nome",
    tabsWorkspaces: "Workspaces",
    tabsRole: "Função",
    editUserWorkspaces: "Editar workspaces do usuário",
    editUserWorkspacesDescription: "Selecione os workspaces que {name} terá acesso",
    editUserWorkspacesHelp: "Marque os workspaces que você deseja vincular a este usuário.",
    editUserRoleTitle: "Definir função do usuário",
    editUserRoleDescription: "Selecione a função que este usuário terá na organização.",
    roleAdmin: "Administrador",
    roleUser: "Usuário",
    editUserWorkspacesButton: "Editar workspaces vinculados",
    editUserSettings: "Editar configurações do usuário",
    noWorkspacesInOrganization: "Não há workspaces na organização",
    updateWorkspacesSuccess: "Salvo com sucesso!",
    updateWorkspacesSuccessDescription: "As configurações do usuário foram salvas.",
    updateWorkspacesError: "Erro ao atualizar workspaces",
    updateWorkspacesErrorDescription: "Ocorreu um erro ao atualizar os workspaces do usuário.",
    deleteUserTitle: "Excluir usuário",
    deleteUserDescription: "Tem certeza que deseja excluir {{name}}? Esta ação não pode ser desfeita.",
    deleteUserButton: "Excluir usuário",
    deleteUserSuccess: "Usuário desativado",
    deleteUserSuccessDescription: "O usuário foi desativado com sucesso do sistema.",
    deleteUserError: "Erro ao desativar usuário",
    deleteUserErrorDescription: "Ocorreu um erro ao tentar desativar o usuário. Tente novamente mais tarde.",
    cannotDeleteSelf: "Você não pode excluir seu próprio usuário",
    removeFromOrgTitle: "Remover da organização",
    removeFromOrgDescription: "{{name}} perde o acesso a esta organização e a todos os workspaces relacionados.",
    removeFromOrgButton: "Remover da organização",
    removeFromOrgSuccess: "Usuário removido",
    removeFromOrgSuccessDescription: "A pessoa não faz mais parte desta organização.",
    removeFromOrgError: "Erro ao remover",
    removeFromOrgErrorDescription: "Não foi possível remover a pessoa desta organização.",
    unlinkUserTitle: "Remover do workspace",
    unlinkUserDescription: "Tem certeza que deseja remover {{name}} deste workspace? O usuário continuará ativo na organização.",
    unlinkUserButton: "Remover do workspace",
    unlinkUserSuccess: "Usuário removido do workspace",
    unlinkUserSuccessDescription: "O usuário foi desvinculado do workspace com sucesso.",
    unlinkUserError: "Erro ao remover usuário do workspace",
    unlinkUserErrorDescription: "Ocorreu um erro ao tentar remover o usuário do workspace. Tente novamente mais tarde.",
    deactivateSuccess: "Usuário desativado com sucesso",
    deactivateSuccessDescription: "O usuário foi desativado do sistema",
    deactivateError: "Erro ao desativar usuário",
    deactivateErrorDescription: "Ocorreu um erro ao desativar o usuário",
    loadingUserData: "Carregando dados do usuário...",
    cancelInvite: "Cancelar convite",
    selectRole: "Selecione uma função",
    selectWorkspaces: "Selecione os workspaces",
    sendInvite: "Enviar Convite",
    inviteButton: "Convidar Usuários",
    inviteSuccess: "Convite enviado com sucesso",
    inviteSuccessDescription: "O usuário receberá um email com instruções.",
    inviteError: "Erro ao enviar convite",
    inviteErrorDescription: "Ocorreu um erro ao enviar o convite.",
    duplicateInviteError: "Usuário com email já cadastrado.",
    userInAnotherOrgError: "Este usuário já está vinculado a outra organização e não pode ser convidado.",
    usersTable: {
      deleteConfirmTitle: "Excluir Usuário",
      deleteConfirmDescription: "Tem certeza que deseja remover {email} da organização?",
      deletePendingConfirmDescription: "Tem certeza que deseja cancelar este convite?",
      inviteDeleteSuccess: "Usuário removido com sucesso",
      inviteDeleteSuccessDescription: "O usuário foi removido da sua organização.",
      inviteDeleteError: "Erro ao remover usuário",
      inviteDeleteErrorDescription: "Ocorreu um erro ao remover o usuário."
    },
    search: {
      placeholder: "Pesquisar por nome ou e-mail",
      tooltip: "Pesquisar usuários",
      clear: "Limpar busca",
      noResults: "Nenhum usuário encontrado"
    }
  },
  logs: {
    title: "Logs",
    description: "Visualize logs em tempo real do sistema",
    selectFile: "Selecionar arquivo de log",
    selectFileToView: "Selecione um arquivo de log para visualizar",
    noFilesFound: "Nenhum arquivo de log encontrado",
    noLogEntries: "Não há entradas de log para exibir",
    refreshFileList: "Atualizar lista de arquivos",
    startStreaming: "Iniciar monitoramento em tempo real",
    stopStreaming: "Parar monitoramento em tempo real",
    start: "Iniciar",
    stop: "Parar",
    clearLogs: "Limpar logs",
    lineCount: "{{count}} linhas",
    streamingActive: "Monitoramento em tempo real ativo",
    streamingStopped: "Monitoramento em tempo real inativo",
    liveStreaming: "Recebendo logs em tempo real",
    terminalTitle: "Terminal de Logs do Sistema",
    fullscreenTitle: "Terminal em Tela Cheia"
  },
  feedback: {
    title: "Feedback",
    description: "Configure quando o formulário de feedback aparece e as opções de GA4.",
    enabled: "Ativar Feedback",
    enabledDescription: "Quando desativado, o popup de feedback fica oculto para todos — inclusive usuários que ainda não responderam.",
    sessionTimeout: "Tempo de sessão (minutos)",
    sessionTimeoutDescription: "Tempo após o login antes do popup de feedback ser exibido. 0 desativa este gatilho.",
    sessionCountThreshold: "Limite de contagem de sessões (logins)",
    sessionCountThresholdDescription: "Mostra o formulário quando o usuário atinge esse número de logins. Combinado com o tempo de sessão por OU — o que disparar primeiro vence. 0 desativa este gatilho.",
    reminderTimeout: "Tempo de lembrete (minutos)",
    ga4Enabled: "Habilitar eventos GA4",
    ga4EnabledDescription: "Quando habilitado, o frontend enviará eventos GA4 de impressão, envio e fechamento do feedback.",
    ga4EventName: "Nome do evento GA4",
    updateSuccess: "Configurações de feedback atualizadas",
    updateError: "Falha ao atualizar configurações de feedback",
    missingConfig: "Execute a migration de settings para criar o registro feedback_form antes de editar aqui.",
    resetTitle: "Resetar feedback dos usuários",
    resetDescription: "Limpa todas as respostas enviadas e reabre o formulário de feedback para todos os usuários. O histórico de eventos é preservado.",
    resetButton: "Resetar Feedback",
    resetting: "Resetando...",
    resetSuccess: "Feedback resetado com sucesso",
    resetCount: "{{count}} perfis foram resetados.",
    resetError: "Falha ao resetar o feedback dos usuários"
  },
  emailSender: {
    useTemplate: "Usar um template",
    useTemplateDescription: "Carregue um template base no editor, ou componha o e-mail do zero.",
    template: "Template",
    selectTemplate: "Selecione um template…",
    subject: "Assunto",
    preview: "Pré-visualizar",
    placeholderHint: "Apenas {{userName}} é substituído por destinatário no envio. Preencha quaisquer outros {{placeholders}} antes de enviar.",
    testEmailTitle: "E-mail de teste",
    testEmailDescription: "Envia AS DUAS versões (EN e PT) para este endereço para você revisar.",
    sendTest: "Enviar teste",
    testSent: "E-mails de teste disparados",
    allUsersTitle: "Usuários da base",
    allUsersDescription: "Envia para todos os usuários cadastrados, escolhendo a versão EN ou PT conforme o idioma do perfil. Roda em segundo plano.",
    sendAll: "Enviar para todos os usuários",
    bulkStarted: "Envio em massa iniciado",
    confirmTitle: "Enviar para TODOS os usuários cadastrados?",
    confirmDescription: "Isto vai enviar e-mail para todos os usuários cadastrados na base. Esta ação não pode ser desfeita. O envio roda em segundo plano.",
    confirmSend: "Sim, enviar para todos"
  },
  emailTemplates: {
    title: "Templates de Email",
    description: "Gerencie os templates de email da sua organização.",
    tabs: {
      base: "Templates Base",
      organization: "Organização"
    },
    noTemplates: "Nenhum template encontrado",
    searchPlaceholder: "Buscar templates...",
    columns: {
      name: "Template",
      slug: "Slug",
      subject: "Assunto",
      language: "Idioma",
      status: "Status",
      actions: "Ações"
    },
    customized: "Customizado",
    default: "Padrão",
    usingSystemDefault: "Usando padrão do sistema",
    edit: "Editar",
    preview: "Preview",
    remove: "Remover",
    removeCustomization: "Remover customização",
    createCustom: "Customizar",
    editor: {
      subject: "Assunto",
      content: "Conteúdo",
      variables: "Variáveis disponíveis",
      save: "Salvar",
      saving: "Salvando...",
      reset: "Restaurar Padrão",
      removeCustomization: "Remover Customização",
      back: "Voltar",
      manageVariables: "Gerenciar variáveis",
      variableKey: "Chave",
      variableDescription: "Descrição",
      variableExample: "Exemplo",
      addVariable: "Adicionar variável",
      noVariables: "Nenhuma variável definida",
      keyRequired: "A chave é obrigatória"
    },
    saveSuccess: "Template salvo com sucesso",
    saveError: "Erro ao salvar template",
    deleteSuccess: "Template customizado removido",
    deleteError: "Erro ao remover template",
    resetSuccess: "Template restaurado ao padrão",
    resetError: "Erro ao restaurar template"
  },
  emailService: {
    title: "Configuração do Serviço de Email",
    description: "Configure o serviço de email para envio de convites, redefinição de senha e notificações.",
    sendingMethod: "Método de Envio",
    emailProtocol: "Protocolo de Email",
    generalSettings: "Configurações Gerais",
    fromEmail: "Email de Origem",
    organizationName: "Nome da Organização",
    testConfiguration: "Testar Configuração",
    testEmail: "Email de Teste",
    testEmailPlaceholder: "seu.email@exemplo.com",
    testEmailHint: "Digite um email para testar a configuração antes de salvar.",
    testConnection: "Testar Conexão",
    saveConfiguration: "Salvar Configuração",
    reset: "Resetar",
    loading: "Carregando configurações...",
    loadError: "Erro ao carregar configurações de email. Verifique se as migrations foram executadas.",
    saveSuccess: "Configuração salva!",
    saveError: "Erro ao salvar",
    testRequired: "Email de teste é obrigatório",
    testSuccess: "Teste bem-sucedido!",
    testFailed: "Falha no teste",
    smtpSection: "SMTP",
    smtpHost: "Servidor SMTP",
    smtpPort: "Porta",
    smtpUser: "Usuário SMTP",
    smtpPassword: "Senha SMTP",
  },
  emailNotifications: {
    title: "Notificações de Email",
    description: "Configure quais emails o Prodgy envia automaticamente.",
    missingConfig: "Execute o seed de email_notifications antes de editar aqui.",
    meetingConfirmation: "Confirmação de reunião",
    meetingConfirmationDescription: "Enviado a todos os participantes quando o Assistant aceita um convite de reunião.",
    meetingCancellation: "Cancelamento de reunião",
    meetingCancellationDescription: "Enviado quando uma reunião com o Assistant é cancelada.",
    meetingError: "Erros do Assistant",
    meetingErrorDescription: "Enviado ao organizador quando o Assistant não consegue participar (usuário não cadastrado, sem workspace, etc).",
    groupAssistant: "Assistant",
    groupApiTokens: "Tokens de API",
    groupUserAccount: "Usuário / Conta",
    apiTokenCreated: "Token criado",
    apiTokenCreatedDescription: "Enviado ao usuário quando um novo token de API é criado.",
    apiTokenExpiring: "Token expirando",
    apiTokenExpiringDescription: "Enviado quando um token de API está prestes a expirar.",
    apiTokenExpired: "Token expirado",
    apiTokenExpiredDescription: "Enviado quando um token de API expirou.",
    apiTokenRevoked: "Token revogado",
    apiTokenRevokedDescription: "Enviado quando um token de API é revogado.",
    invite: "Convite de usuário",
    inviteDescription: "Enviado aos usuários quando são convidados para a organização.",
    alreadyRegistered: "Email já cadastrado",
    alreadyRegisteredDescription: "Enviado quando uma tentativa de cadastro é feita com um email já registrado.",
    meetingScriberWelcome: "Boas-vindas ao Meeting Scriber",
    meetingScriberWelcomeDescription: "Enviado aos usuários ao serem integrados ao Meeting Scriber.",
    saveSuccess: "Configurações de notificação salvas",
    saveError: "Erro ao salvar configurações de notificação"
  },
  plansAdmin: {
    tabs: {
      plans: "Planos",
      waitlists: "Listas de Espera"
    },
    list: {
      newPlan: "Novo Plano",
      name: "Nome",
      slug: "Slug",
      price: "Preço",
      billing: "Cobrança",
      permissionList: "Lista de Permissão",
      active: "Ativo",
      actions: "Ações",
      empty: "Nenhum plano ainda. Clique em \"Novo Plano\" para começar."
    },
    delete: {
      title: "Excluir plano?",
      description: "Isso excluirá permanentemente {{name}}. Esta ação não pode ser desfeita.",
      cancel: "Cancelar",
      confirm: "Excluir",
      deleting: "Excluindo…"
    },
    editor: {
      newTitle: "Novo Plano",
      editTitle: "Editar Plano — {{name}}",
      tabs: {
        general: "Geral",
        features: "Recursos e Metadados",
        limits: "Limites e Créditos",
        access: "Controle de Acesso"
      },
      name: "Nome",
      slug: "Slug",
      slugPlaceholder: "ex. trial",
      sortOrder: "Ordem",
      active: "Ativo",
      description: "Descrição",
      billingCycle: "Ciclo de Cobrança",
      billingSelectPlaceholder: "Selecione…",
      billingMonthly: "Mensal",
      billingSemiAnnual: "Semestral",
      billingAnnual: "Anual",
      billingLifetime: "Vitalício",
      trialDays: "Dias de Trial",
      priceUsd: "Preço (USD)",
      priceBrl: "Preço (BRL)",
      invoiceEnabled: "Faturamento habilitado",
      features: "Recursos",
      restrictions: "Restrições",
      badge: "Selo",
      ctaText: "Texto do CTA",
      color: "Cor",
      colorPlaceholder: "ex. blue",
      popular: "Popular",
      highlight: "Destaque",
      add: "Adicionar",
      english: "Inglês",
      portuguese: "Português",
      creditsLimit: "Limite de Créditos (null = ilimitado)",
      creditsLimitPlaceholder: "Deixe vazio para ilimitado",
      creditsLabel: "Rótulo dos Créditos",
      creditUnitCosts: "Custos Unitários em Créditos",
      fixedLimits: "Limites Fixos",
      keyPlaceholder: "Chave",
      costPlaceholder: "Custo",
      labelEnPlaceholder: "Rótulo EN",
      maxPlaceholder: "Máx (null=∞)",
      permissionList: "Lista de Permissão (Lista de Espera)",
      permissionListNone: "Nenhuma",
      permissionListHint: "Quando definido, o acesso a este plano é restrito a quem está na lista de espera selecionada.",
      integrationsKey: "Chave da Lista de Integrações",
      integrationsKeyPlaceholder: "ex. trial_integrations",
      integrationsKeyHint: "Nome da lista de integrações permitidas para este plano.",
      cancel: "Cancelar",
      saving: "Salvando…",
      saveChanges: "Salvar Alterações",
      createPlan: "Criar Plano",
      saveError: "Falha ao salvar o plano.",
      errors: {
        nameRequired: "Informe o nome do plano.",
        slugRequired: "Informe o slug.",
        slugInvalid: "Use apenas letras minúsculas, números e hífens.",
        summary: "Revise os campos destacados."
      }
    }
  },
  waitlists: {
    title: "Listas de Espera",
    description: "Gerencie listas de controle de acesso vinculadas aos planos.",
    newWaitlist: "Nova Lista de Espera",
    empty: "Nenhuma lista de espera ainda. Clique em \"Nova Lista de Espera\" para criar uma.",
    contactsCount: "{{count}} contatos",
    newDialog: {
      title: "Nova Lista de Espera",
      keyLabel: "Chave (tipo de configuração)",
      keyPlaceholder: "ex. waitlist_beta",
      keyHint: "Identificador único usado no campo permission_list do plano.",
      label: "Rótulo",
      english: "Inglês",
      portuguese: "Português",
      createError: "Falha ao criar a lista de espera.",
      cancel: "Cancelar",
      creating: "Criando…",
      create: "Criar Lista de Espera"
    },
    contacts: {
      total: "Total",
      searchPlaceholder: "Buscar e-mail…",
      addContact: "Adicionar Contato",
      email: "E-mail",
      status: "Status",
      noMatch: "Nenhum contato corresponde à sua busca.",
      empty: "Nenhum contato ainda.",
      removeTitle: "Remover contato?",
      removeDescription: "Isso removerá {{email}} da lista de espera permanentemente.",
      cancel: "Cancelar",
      removing: "Removendo…",
      remove: "Remover"
    },
    addDialog: {
      title: "Adicionar Contato",
      email: "E-mail",
      emailPlaceholder: "usuario@exemplo.com",
      status: "Status",
      invalidEmail: "Digite um endereço de e-mail válido.",
      addError: "Falha ao adicionar o contato.",
      cancel: "Cancelar",
      adding: "Adicionando…",
      add: "Adicionar Contato"
    }
  },
  dashboardLayouts: {
    title: "Layouts padrão",
    intro: "Layouts padrão por escopo. Aparecem para usuários sem layout próprio e para organizações/workspaces sem um layout específico. Para definir, abra a tela de dashboards do escopo correspondente e clique em",
    introBold: "Salvar como Padrão → Superadmin / Todas as Organizações / Todos os Workspaces",
    loading: "Carregando…",
    noLayout: "Sem layout definido",
    tabs_one: "{{count}} aba",
    tabs_other: "{{count}} abas",
    slots_one: "{{count}} slot",
    slots_other: "{{count}} slots",
    clear: "Limpar",
    clearing: "Limpando…",
    clearTitle: "Limpar layout padrão?",
    clearDescription: "Usuários sem layout próprio (e orgs/produtos sem um layout específico) passarão a ver uma dashboard vazia no escopo {{scope}}.",
    cancel: "Cancelar",
    cleared: "Layout padrão limpo",
    clearFailed: "Falha: {{message}}",
    scopes: {
      superadminLabel: "Superadmin",
      superadminDescription: "Layout padrão que superadmins veem ao abrir a tela de dashboards (escopo plataforma).",
      organizationLabel: "Organização",
      organizationDescription: "Layout padrão que usuários veem nas dashboards da organização quando não há override.",
      productLabel: "Workspace",
      productDescription: "Layout padrão das dashboards do workspace quando não há override."
    }
  },
  dashboardTemplateEditor: {
    editTitle: "Editar template de dashboard",
    newTitle: "Novo template de dashboard",
    tabBasic: "Básico",
    tabDatasources: "Datasources",
    tabAdvanced: "Avançado",
    tabPreview: "Preview",
    nameEn: "Nome (Inglês)",
    namePt: "Nome (Português)",
    namePlaceholderEn: "Platform Health",
    namePlaceholderPt: "Saúde da Plataforma",
    descEn: "Descrição (Inglês)",
    descPt: "Descrição (Português)",
    category: "Categoria",
    icon: "Ícone",
    type: "Tipo",
    scope: "Escopo",
    active: "Ativo (distribuir em novas organizações/produtos)",
    datasourcesHint1: "Lista de datasources como array JSON. Cada item:",
    datasourcesHint2: "Para",
    datasourcesHint3: "use uma das métricas do catálogo abaixo.",
    metricsCatalog: "Catálogo de métricas internas",
    noMetrics: "Nenhuma métrica disponível para este escopo.",
    previewHint: "Executa os datasources com dados reais (escopo superadmin para o escopo superadmin, ou sua organização para os demais). Não persiste nada.",
    runningPreview: "Executando…",
    runPreview: "Executar preview",
    cancel: "Cancelar",
    saving: "Salvando…",
    save: "Salvar",
    create: "Criar",
    templateUpdated: "Template atualizado",
    templateCreated: "Template criado",
    nameRequired: "Nome (en e pt) é obrigatório.",
    unknownError: "Erro desconhecido"
  },
  workspaces: {
    title: "Workspaces",
    description: "Gerencie os workspaces de agentes.",
    addWorkspace: "Workspace",
    editWorkspace: "Editar Workspace",
    dialogDescription: "Digite os detalhes do workspace abaixo.",
    fields: {
      name: "Nome",
      namePlaceholder: "Digite o nome do workspace",
      slug: "Slug",
      slugPlaceholder: "slug-do-workspace",
      slugHelper: "Identificador usado nos comandos do comunicador (ex: /prodgy use meu-workspace). Auto-gerado a partir do nome se vazio.",
      description: "Descrição",
      descriptionPlaceholder: "Digite a descrição do workspace",
      website: "Site",
      websitePlaceholder: "https://exemplo.com",
      websiteHelper: "Você pode digitar com ou sem https:// (ex: exemplo.com)",
      logo: "Logo",
      userName: "Nome do Usuário",
      userEmail: "Email",
      access: "Acesso",
      users: "Usuários",
      avatar: "Avatar"
    },
    noName: "Sem Nome",
    saveSuccess: "Workspace salvo com sucesso",
    saveSuccessDescription: "Seu workspace foi salvo.",
    saveError: "Erro ao salvar workspace",
    saveErrorDescription: "Ocorreu um erro ao salvar o workspace.",
    deleteConfirmTitle: "Excluir Workspace",
    deleteConfirmDescription: "Tem certeza que deseja excluir este workspace? Esta ação não pode ser desfeita.",
    deleteSuccess: "Workspace excluído com sucesso",
    deleteSuccessDescription: "O workspace e todas as suas dependências foram removidos.",
    deletePartialSuccess: "Workspace parcialmente excluído",
    deletePartialSuccessDescription: "Algumas dependências do workspace podem não ter sido removidas completamente.",
    deleteError: "Erro ao excluir workspace",
    deleteErrorDescription: "Ocorreu um erro ao excluir o workspace.",
    deleteBlockedDescription: "Remova os {{blockers}} deste workspace antes de excluí-lo.",
    deletingWorkspace: "Excluindo workspace",
    deletingWorkspaceMessage: "Excluindo {{workspaceName}} e suas dependências. Por favor, aguarde...",
    logoUpdateSuccess: "Logo atualizado com sucesso",
    logoUpdateSuccessDescription: "O logo do workspace foi atualizado.",
    logoUpdateError: "Erro ao atualizar logo",
    users: "usuários",
    generalTab: "Informações Gerais",
    usersTab: "Usuários",
    addUser: "Adicionar Usuário",
    searchUsers: "Buscar usuários...",
    noUsersFound: "Nenhum usuário encontrado",
    fillRequiredFields: "Preencha os campos obrigatórios do workspace",
    nameRequired: "O nome do workspace é obrigatório",
    noUsersInOrg: "Não há usuários ativos na organização para adicionar",
    inviteUserCta: "Convide mais usuários para seu workspace agora mesmo!",
    noOtherUsers: "Não há outros usuários na organização além de você.",
    addUsersButton: "+ Usuários",
    alreadyMember: "Já é membro",
    meLabel: "(Eu)",
    pendingInvites: "Convites Enviados",
    noWorkspaces: "Nenhum workspace cadastrado",
    noWorkspacesDescription: "Comece criando seu primeiro workspace para gerenciar agentes de IA e recursos.",
    errors: {
      nameRequired: "O nome do workspace é obrigatório",
      organizationNotFound: "Organização não encontrada",
      saveFailed: "Falha ao salvar o workspace"
    },
    messages: {
      updateSuccess: "Informações do workspace atualizadas com sucesso"
    },
    apiTokens: {
      title: "Tokens de API",
      description: "Gerencie tokens de API a nível de workspace para acesso de terceiros",
      create: "Criar",
      createToken: "Criar Token de API",
      createDescription: "Crie um novo token vinculado a este workspace.",
      successDescription: "Seu token de API foi criado com sucesso. Você pode copiá-lo agora ou acessá-lo depois da lista de tokens.",
      tokenName: "Nome do token",
      tokenNamePlaceholder: "ex: Integração Produção",
      setExpiration: "Definir expiração",
      expiresAt: "Expira em",
      cancel: "Cancelar",
      done: "Concluído",
      yourApiToken: "Seu Token de API",
      copyToken: "Copiar token",
      copyFullToken: "Copiar token completo (expira em 30s)",
      copyPrefix: "Copiar prefixo do token (regenere para obter token completo)",
      regenerate: "Regenerar",
      regenerateTitle: "Regenerar token - cria um novo token e mostra para você",
      regenerateSuccess: "Token regenerado com sucesso",
      active: "Ativo",
      inactive: "Inativo",
      created: "Criado",
      expires: "Expira",
      usageCount: "Contagem de uso",
      noTokens: "Nenhum Token de API",
      noTokensDescription: "Crie um token de API para permitir que integrações de terceiros acessem endpoints específicos.",
      createFirstToken: "Criar seu primeiro token",
      availableApis: "APIs Disponíveis",
      apisDescription: "Endpoints acessíveis com tokens de API deste workspace",
      swaggerLink: "Para detalhes completos dos endpoints, consulte a documentação Swagger",
      tokenCopied: "Token copiado para a área de transferência",
      tokenPrefixCopied: "Prefixo do token copiado para a área de transferência",
      important: "Importante: Copie este token agora! Após fechar esta caixa de diálogo, apenas o prefixo do token será mostrado por razões de segurança. O token completo não pode ser recuperado depois.",
      error: "Erro",
      failedToCreate: "Falha ao criar token de API",
      failedToRevoke: "Falha ao revogar token",
      failedToRenew: "Falha ao renovar token",
      failedToRegenerate: "Falha ao regenerar token",
      failedToCopy: "Falha ao copiar token",
      failedToCopyPrefix: "Falha ao copiar prefixo do token",
      tokenRevoked: "Token revogado",
      tokenRenewed: "Token renovado com sucesso"
    }
  }
} as const;
